<template>
<BaseTemplate>
  <div class="base">
    <Title jpn="Personal info"></Title>
    <div class="input-area">
      <SubTitle>Name</SubTitle>
      <div class="address_area flex">
        <div class="last-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="lastName"
          />
        </div>
        <div class="first-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="middleName"
          />
        </div>
        <div class="first-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="firstName"
          />
        </div>
      </div>
      <div class="address_area">
        <LabelItem
          class="label-item"
          label="Country"
          :text="countryName"
        />
        <LabelInput
          class="label-input"
          labelText="Zip code"
        >
          <LabelItem
            class="label-item referralCode"
            :text="zipCode"
          />
        </LabelInput>
        <LabelInput class="label-input" labelText="Prefecture">
          <LabelItem
            class="label-item referralCode"
            :text="country"
          />
        </LabelInput>
        <LabelInput class="label-input" labelText="City">
          <LabelItem
            class="label-item referralCode"
            :text="shiku"
          />
        </LabelInput>
        <LabelInput class="label-input" labelText="Address1">
          <LabelItem
            class="label-item referralCode"
            :text="address"
          />
        </LabelInput>
        <LabelInput
          class="label-input"
          labelText="Address2"
        >
          <LabelItem
            class="label-item referralCode"
            :text="building"
          />
        </LabelInput>
      </div>

      <SubTitle>Tel</SubTitle>
      <div class="address_area">
        <TextBox
          class="text-box tel"
          inputType="text"
          :value="tel"
          :readonly="end_sms == 1"
          placeholder="01234567890"
          @handleTextInput="inputTel"
        />
        <ErrorMessage
          v-if="errorMessageTel"
          class="error-message"
          :message="errorMessageTel"
        />
        <div class="button_area">
          <BlackGradationButton
            class="label-input nomt sms_button"
            text="SMS Authentication"
            v-if="end_sms == 0"
            @handleSquareBtnClick="smsPopup"
          />
        </div>
      </div>

      <SubTitle>Email address</SubTitle>
      <div class="address_area">
        <LabelItem
          class="label-item"
          :text="mail"
        />
      </div>

      <SubTitle v-if="referral_code != ''">Referral Code</SubTitle>
      <div v-if="referral_code != ''" class="address_area">
        <LabelItem
          class="label-item referralCode"
          :text="referral_code"
        />
        <div class="referral_message" v-if="referral_code != ''">You can introduce up to 10 friends only if you have completed SMS authentication and have made at least one payment on this site. After registration, if your friend completes SMS authentication, both parties will receive 1000P.</div>
      </div>
    </div>
    <div class="button_area">
      <BlackGradationButton
        class="square-button"
        text="Update Info"
        @handleSquareBtnClick="upadateUserInfo"
      />
      <SquareButton
        class="label-input nomt square-button"
        text="Back"
        @handleSquareBtnClick="goToBack"
      />
    </div>
  </div>
  <AlertSuccess
    ref="alertSuccess"
    :isShow="isShowAlertSuccess"
    text="Setup complete"
    v-click-outside="closeAlertSuccess"
  />
  <AlertSuccess
    ref="alertSMSSuccess"
    :isShow="isShowSMSAlertSuccess"
    text="Setup complete"
    v-click-outside="closeSMSAlertSuccess"
  />
  <SMSPopup
    v-if="showSMSPopup"
    :tel="tel"
    @success="smsSuccess"
    @closePopup="showSMSPopup = false">
  </SMSPopup>
</BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import AlertSuccess from '@/components/atoms/AlertSuccess.vue';
import SMSPopup from '@/components/molecules/SMSPopup.vue';
import LabelItem from '@/components/molecules/LabelItem.vue';
import Title from '@/components/molecules/Title.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    AlertSuccess,
    LabelItem,
    TextBox,
    SMSPopup,
    ErrorMessage,
    LabelInput,
    Title,
    SubTitle,
    SquareButton,
    BlackGradationButton,
  },

  data: () => ({
    lastName: null,
    middleName: null,
    firstName: null,
    tel: null,
    mail: null,
    zipCode: null,
    prefectureId: null,
    country: null,
    shiku: null,
    address: null,
    building: null,
    password: null,
    point: null,
    end_sms: 0,
    referral_code: '',
    countryId: null,
    confirmPass: null,
    showSMSPopup: false,
    isShowAlertSuccess: false,
    isShowSMSAlertSuccess: false,
    errorMessageLastName: null,
    errorMessageMiddleName: null,
    errorMessageFirstName: null,
    errorMessageTel: null,
    errorMessageMail: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageCountry: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      logOutUserResult: 'user/logOutUserResult',
      countryList: 'country/countryList',
    }),
    countryName() {
      if (this.countryList) {
        if (this.countryId && this.countryId !== '0') {
          return this.countryList.find(
            (country) => country.id === this.countryId,
          ).name;
        }
      }
      return null;
    },
  },

  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.middleName = newResult.middleName;
        this.firstName = newResult.firstName;
        this.tel = newResult.tel;
        this.mail = newResult.mail;
        this.zipCode = newResult.zipcode;
        // this.prefectureId = newResult.pref_id;
        this.country = newResult.country;
        this.shiku = newResult.shiku;
        this.address = newResult.address;
        this.building = newResult.building;
        this.point = newResult.availablePoint;
        this.end_sms = newResult.end_sms;
        this.referral_code = newResult.referral_code;
        this.countryId = newResult.country_id;
        // MEMO: 都道府県リストが更新されないため、レンダリング完了を待ち、さらに少し時間差をつける。（100に根拠はないが、リロードして動作を確認）
        setTimeout(() => {
          this.prefectureId = newResult.pref_id;
        }, 100);
      });
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isShowAlertSuccess = true;
        } else {
          const {
            lastName, firstName, middleName, tel, mail, zipcode,
            pref_id: prefId, shiku, address, building,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
  },

  created() {
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('user/setCurrentUserDetail');
    this.$store.dispatch('country/setCountryList');
  },

  methods: {
    inputLastName(lastName) {
      this.lastName = lastName;
    },
    inputFirstName(firstName) {
      this.firstName = firstName;
    },
    inputMiddleName(name) {
      this.middleName = name;
    },
    inputTel(tel) {
      this.tel = tel;
    },
    inputMail(mail) {
      this.mail = mail;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    changeZipCode() {
      if (this.i18n_mode === 'jp') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    smsPopup() {
      if (window.confirm(this.t('SMSコードを送信しますか？'))) {
        this.showSMSPopup = true;
      }
    },
    goToBack() {
      this.$router.push('/my-page');
    },
    goToChangePassword() {
      this.$router.push('/change-password');
    },
    upadateUserInfo() {
      if (this.i18n_mode !== 'jp') {
        this.prefectureId = 99;
      }
      const postParams = {
        // lastName: this.lastName,
        // middleName: this.middleName,
        // firstName: this.firstName,
        tel: this.tel,
        // mail: this.mail,
        // zipcode: this.zipCode,
        // pref_id: this.prefectureId,
        // country: this.country,
        // shiku: this.shiku,
        // address: this.address,
        // building: this.building,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    closeAlertSuccess() {
      this.isShowAlertSuccess = false;
    },
    closeSMSAlertSuccess() {
      this.isShowSMSAlertSuccess = false;
    },
    smsSuccess() {
      this.showSMSPopup = false;
      this.$store.dispatch('user/setCurrentUserDetail');
      this.isShowSMSAlertSuccess = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;
  .input-area {
    margin: 0;
    padding: 0 10px;
    .address_area {
      padding: 0;
      margin: 10px 0;
      .row {
        margin: 5px 0;
      }
      .label-input {
        margin-top: 10px;
      }
    }
    .flex {
      display: flex;
      width: 100%;
      .last-name-container{
        flex: 1 1 150px;
        min-width: 0;
      }
      .first-name-container{
        flex: 1 1 150px;
        min-width: 0;
        margin-left: 15px;
      }
    }
    .announce-area {
      display: flex;
      align-items: center;
      .announce {
        color: $black;
        margin-left: 10px;
        font-size: 14px;
        width: 300px;
      }
    }
  }
  .button_area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .square-button {
      max-width: 200px;
      width: 100%;
      &:nth-child(2) {
        margin-top: 10px;
      }
    }
  }
  .referralCode {
    font-size: 24px;
  }
  .referral_message {
    color: $white;
  }
}
@media screen and (max-width: $tabletWidth) {
  .base {
    .input-area {
      margin: 10px 0;
    }
  }
}
</style>
